module.exports = __webpack_public_path__ + "img/profissionais-pec-cnes.a4ad3ca9.jpeg";